import { createSlice } from '@reduxjs/toolkit';
import BigNumber from "bignumber.js";
import axios from 'axios';

const initialState = {
    proposals: {},
    proposalStates: {},
    proposalData: {},
    proposalUserReceipts: {},
    blockNumber: null
}

const governorSlice = createSlice({
    name: 'governor',
    initialState,
    reducers: {
        setProposals(state, action) {
            state.proposals = {...state.proposals, ...Object.fromEntries(action.payload.map(p => [p.id, p]))};
        },
        setProposalEvent(state, action) {
            state.proposals[action.payload.id] = action.payload.proposal;
        },
        setProposalState(state, action) {
            state.proposalStates[action.payload.id] = action.payload.state;
        },
        setProposalData(state, action) {
            state.proposalData[action.payload.id] = action.payload.proposal;
        },
        setProposalReceipt(state, action) {
            state.proposalUserReceipts[action.payload.id] = action.payload.receipt;
        },
        setBlockNumber(state, action) {
            state.blockNumber = action.payload;
        }
    },
});

export const {
    setProposals,
    setProposalEvent,
    setProposalState,
    setProposalData,
    setProposalReceipt,
    setBlockNumber
} = governorSlice.actions;
export default governorSlice.reducer;

function fetchBlockNumber({provider}) {
    return dispatch => {
        if (provider) {
            provider.getBlockNumber().then(block => {
                dispatch(setBlockNumber(block));
            });
        }
    }
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

function fetchProposals({governor, blockNumber}) {
    return dispatch => {
        // TODO(NIKITA): Change it back to env url
        // process.env.REACT_APP_API_URL + "/dao/proposals"
        axios.get("https://api.roobee.finance/dao/proposals").then(res => {    
            const proposals = res.data;

            dispatch(setProposals(proposals));
        });
    };
}

function fetchProposalState({governor}, id) {
    return dispatch => {
        if (governor) {
            governor.state(id).then(result => {
                dispatch(setProposalState({id: id.toString(), state: result}));
            });
        }
    };
}

function fetchProposalData({governor}, id) {
    return dispatch => {
        if (governor) {
            governor.proposals(id).then(result => {
                dispatch(setProposalData({id, proposal: result}));
            });
        }
    };
}

function fetchProposalDetails({governor, account, block}, id) {
    return dispatch => {
        if (governor && block) {
            governor.proposals(id).then(result => {
                dispatch(setProposalData({id, proposal: result}));
            });

            const queryBlock = Number.parseInt(process.env.REACT_APP_ONLY_FETCH_BLOCK);
            governor.queryFilter(
                'ProposalCreated',
                queryBlock - 1000,
                queryBlock + 1000
            ).then(result => {
                const event = result.find(e => e.args.id.toString() === id);
                if (event) {
                    dispatch(setProposalEvent({id, proposal: event.args}));
                }
            });

            governor.getReceipt(id, account).then(result => {
                dispatch(setProposalReceipt({id, receipt: result}));
            });
        }
    };
}

export { 
    fetchBlockNumber,
    fetchProposals,
    fetchProposalData,
    fetchProposalDetails,
    fetchProposalState
};
